import { render, staticRenderFns } from "./shanxiStudentList.vue?vue&type=template&id=6820c29c"
import script from "./shanxiStudentList.vue?vue&type=script&lang=js"
export * from "./shanxiStudentList.vue?vue&type=script&lang=js"
import style0 from "./shanxiStudentList.vue?vue&type=style&index=0&id=6820c29c&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports